module.exports = __webpack_public_path__ + "static/media/ice41.888e09e1.webp";